import { cloneDeep } from 'lodash';

import { SerializableObject } from '../../generic/serialization/serializable-object';
import { SerializableObjectSchema } from '../../generic/serialization/serializable-object-schema';

import { ConferenceParticipantConstructor } from './conference-participant-constructor';
import { ConferenceParticipantSchema } from './conference-participant-schema';

export class ConferenceParticipant extends SerializableObject {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////

  protected callSid!: string;

  protected label!: string | undefined;

  protected coaching!: boolean | undefined;

  protected muted!: boolean | undefined;

  protected hold!: boolean | undefined;

  protected status!: string | undefined;

  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(parameters: ConferenceParticipantConstructor) {
    super(parameters);
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  /**
   * This static function is private, and meant to be called only by
   * SerializableObject, and subclasses
   *
   * @param validationResult
   */
  protected static _deserialize(validationResult: import('joi').ValidationResult): ConferenceParticipant {
    return new ConferenceParticipant(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(ConferenceParticipant.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): SerializableObjectSchema {
    return new ConferenceParticipantSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getCallSid(): string {
    return cloneDeep(this.callSid);
  }

  public getLabel(): string | undefined {
    return cloneDeep(this.label);
  }

  public getCoaching(): boolean | undefined {
    return cloneDeep(this.coaching);
  }

  public getMuted(): boolean | undefined {
    return cloneDeep(this.muted);
  }

  public getHold(): boolean | undefined {
    return cloneDeep(this.hold);
  }

  public getStatus(): string | undefined {
    return cloneDeep(this.status);
  }
}
